"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassSorts = void 0;
var ClassSorts;
(function (ClassSorts) {
    ClassSorts["ClassNameAsc"] = "CLASS_NAME_ASC";
    ClassSorts["ClassNameDesc"] = "CLASS_NAME_DESC";
    ClassSorts["CreateDateAsc"] = "CREATE_DATE_ASC";
    ClassSorts["CreateDateDesc"] = "CREATE_DATE_DESC";
})(ClassSorts || (exports.ClassSorts = ClassSorts = {}));
